import { TFunction } from 'i18next'
import * as yup from 'yup'
export const updateBussinessSchema = (t: TFunction<'translation', undefined>) =>
    yup.object().shape({
        provider_explaination: yup.string().when('explaination_result', {
            is: 'followup',
            then: (schema) => schema.required(t('blank-errors')),
            otherwise: (schema) => schema.notRequired(),
        }),
        influencer_explaination: yup.string().when('explaination_result', {
            is: 'followup',
            then: (schema) => schema.required(t('blank-errors')),
            otherwise: (schema) => schema.notRequired(),
        }),
        problem_explaination: yup.string().when('explaination_result', {
            is: 'followup',
            then: (schema) => schema.required(t('blank-errors')),
            otherwise: (schema) => schema.notRequired(),
        }),
        failed_improvement: yup.string().when('explaination_result', {
            is: 'closed',
            then: (schema) => schema.required(t('blank-errors')),
            otherwise: (schema) => schema.notRequired(),
        }),
    })
